/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";
import { useSelector } from "react-redux";
import CMSCODTableComponent from "./CMSCODTableComponent";

const CMSCOD = (props) => {
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );

  return (
    <div className="row">
      <CMSCODTableComponent
        currentNDCDetailsSelected={currentNDCDetailsSelected}
        {...props}
      />
    </div>
  );
};

export default CMSCOD;
